// USER ROLES
export const userRoles = {
  admin: {
    access: ["*"],
  },
};
